import { TabPanel } from 'src/components/game-tabs';
import { useBracket } from './BracketProvider';
import { memo } from 'react';

export type HeatTabsContentProps = {
  selectedHeatIndex: number;
};

export const HeatTabsContent = memo(function HeatTabsContent({
  selectedHeatIndex,
}: HeatTabsContentProps) {
  const { heatTabs } = useBracket();
  return (
    <>
      {heatTabs.map((heatTab, index) => {
        if (!!heatTab) {
          const { name, content } = heatTab;
          return (
            <TabPanel key={name} value={selectedHeatIndex} index={index}>
              {content}
            </TabPanel>
          );
        }
      })}
    </>
  );
});
